"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var sendMessage = function sendMessage(script) {
  return function (message) {
    script.dispatchEvent(new CustomEvent('message', {
      detail: {
        message: message
      }
    }));
  };
};
var _default = exports["default"] = sendMessage;